<div class="buttons-container" fxFlex fxLayout>
  <div class="container" fxFlex="">
    <button
      mat-flat-button
      color="primary"
      (click)="submit.emit()"
      [disabled]="!formValid || form.pristine"
      cdkFocusInitial
    >
      {{ 'common.save' | translate }}
    </button>

    <!--    <button-->
    <!--      mat-flat-button-->
    <!--      color="primary"-->
    <!--      class="btn-primary"-->
    <!--      (click)="submit.emit()"-->
    <!--      [disabled]="!form.valid || form.pristine"-->
    <!--    >-->
    <!--      <mat-icon class="mat-18">save</mat-icon>-->
    <!--      {{ 'common.save' | translate }}-->
    <!--    </button>-->

    <!--    <button mat-flat-button class="btn-secondary btn-cancel" (click)="cancel.emit()">-->
    <!--      {{ 'common.cancel' | translate }}-->
    <!--    </button>-->

    <button mat-stroked-button (click)="cancel.emit()">{{ 'common.cancel' | translate }}</button>
    <button
      mat-stroked-button
      *ngIf="!isEdit && !isClone && isSaveAddNew"
      mat-flat-button
      color="primary"
      class="btn-primary"
      (click)="saveAddNew.emit()"
      [disabled]="!form.valid || form.pristine"
    >
      {{ 'common.save_add_new' | translate }}
    </button>
  </div>
</div>
